<template>
    <div class="field-item personal-info space-info">
      <form>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="pro-form-img">
              <div class="profile-pic">Foto de Perfil</div>
              <div class="upload-files">
                <label class="file-upload image-upbtn">
                  <i class="feather-upload me-2"></i>Cargar Foto
                  <input type="file" />
                </label>
                <span>Se recomienda que la foto debe tener un tamaño de 450x450 y un tamaño máximo de 5mb.</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Nombres</label>
              <input type="text" class="form-control" v-model="name"/>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Apellido Paterno</label>
              <input type="text" class="form-control" v-model="first_surname"/>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Apellido Materno</label>
              <input type="text" class="form-control" v-model="second_surname"/>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="form-label">Tipo de Documento</label>
              <vue-select :options="typeDocs" id="type_doc" placeholder="Select" v-model="n_doc"/>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">N° Documento</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Celular</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Fecha de Nacimiento</label>
              <div class="cal-icon">
                <datepicker
                  v-model="startdate"
                  placeholder="Choose Date"
                  class="form-control datetimepicker"
                  :editable="true"
                  :clearable="false"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="form-label">Género</label>
              <vue-select :options="genders" id="gender" placeholder="Select" />
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="input-block">
              <label class="form-label">Nacionalidad</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="input-block min-characters">
              <label class="form-label">¿Como te describirías?</label>
              <textarea class="form-control" rows="5"></textarea>
            </div>
          </div>
          <!-- <div class="col-md-6 col-lg-6">
            <div class="input-block">
              <label class="form-label">Email Address</label>
              <input type="text" class="form-control" />
            </div>
          </div> -->
          <!-- <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="form-label">Your Job Title</label>
              <input type="text" class="form-control" />
            </div>
          </div>
          <div class="col-md-6 col-lg-4">
            <div class="input-block">
              <label class="form-label">Type of Job</label>
              <vue-select :options="Job" id="job" placeholder="Select" />
            </div>
          </div> -->
        </div>
      </form>
    </div>
  </template>
  
  
  <script>
  import { ref } from "vue";
  const currentDate = ref(new Date());
  export default {
    data() {
      return {
        Job: ["Select", "Full Time", "Part Time", "Hourly"],
        typeDocs:["C.E.","DNI"],
        genders:["Masculino","Femenino"],
        startdate: currentDate,
      }
    },
  }
  </script>